<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p><span href="#/c001" title="Link target outside of Sample">Title Page</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Page</span></p>
<p><a href="#/c003">The first song | Florians Tale</a></p>
<p><a href="#/c004">For all those who like fairy tales | and are ready to engage in an | alternative version.</a></p>
<p><a href="#/c005">The first song | by | Susanne Eisele</a></p>
<p><a href="#/c006">freely adapted from the fairy tale | Rumpelstiltskin | by the Brothers Grimm</a></p>
<p><span href="#/c007" title="Link target outside of Sample">ACKNOWLEDGEMENT</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4c4e94d2